<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"
         :width="width" :height="height"
    >

        <g>
	<rect y="0" style="opacity: 0" :width="width" :height="height"/>
            <path class="svg-secondary-color" d="M12,3c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.5,0-0.9-0.1-1.4c-1,1.4-2.6,2.3-4.4,2.3c-3,0-5.4-2.4-5.4-5.4
		c0-1.8,0.9-3.4,2.3-4.4C12.9,3,12.5,3,12,3L12,3z"/>
</g>
</svg>

</template>

<script>
export default {
    name: "highContrastDarkIcon",
    props: {
        width: {
            type: Number,
            default: 20
        },
        height: {
            type: Number,
            default: 20
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/highContrastDarkIcon.vue